import { Badge, Modal } from "flowbite-react";
import { useContext } from "react";
import { IAppContextState, AppContext } from "../../../App";
import { Link } from "react-router-dom";
import { WarmPawsGallery } from "../../../components/image-gallery/warmpaws-gallery";

export const WarmPawsModalData = () => {
  const { warmPawsModalState } = useContext<IAppContextState | any>(AppContext);
  const [isOpenWarmPawsModal, setOpenWarmPawsModal] = warmPawsModalState;

  return (
    <Modal
      size={"5xl"}
      position={"top-center"}
      show={isOpenWarmPawsModal}
      onClose={() => setOpenWarmPawsModal(false)}
    >
      <Modal.Header>WarmPaws Homepage</Modal.Header>
      <Modal.Body>
        <div className="flex flex-wrap">
          <div className="md:w-[50%] w-full pe-2">
            <WarmPawsGallery />
          </div>
          <div className="md:w-[50%] w-full ps-2 md:mt-0 mt-6 flex flex-col justify-between">
            <div>
              <h3 className="font-bold text-xl">
                Project name:{" "}
                <span className="text-sky-600">
                  WarmPaws - Pet care in winter
                </span>
              </h3>
              <p className="mt-4 mb-2 text-md text-[15px]">Tech used:</p>
              <div className="flex">
                <Badge color="red" className="me-2 my-1">
                  React
                </Badge>
                <Badge color="yellow" className="me-2 my-1">
                  daisyUI
                </Badge>
                <Badge color="blue" className="me-2 my-1">
                  Firebase Auth
                </Badge>
                <Badge color="pink" className="my-1">
                  TailwindCSS
                </Badge>
              </div>
              <div className="mt-5 mb-2 ">
                <p className="font-semibold">Description:</p>
                <p className="text-[15px]">
                  WarmPaws is a cozy winter companion platform designed for pet
                  owners to ensure their furry friends stay warm, safe, and
                  healthy during the cold season. Users can explore local pet
                  care services, winter pet clothing, grooming options, and
                  expert tips — all in one friendly interface.
                </p>
              </div>
            </div>
            <div className="mt-10">
              <Link
                target="_blank"
                rel="noreferrer"
                to="https://warmpaws.netlify.app/"
                className="text-sky-500 hover:text-sky-700 hover:underline"
              >
                Go to website
              </Link>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
